import React from 'react';
import { challenges } from '../data/content';
export function Challenges() {
  return <section className="bg-graphite px-3 py-4 sm:px-6" data-id="element-29" data-mp="1y2az54j8ypd5">
      <div className="mx-auto max-w-2xl" data-id="element-30" data-mp="1y3uij4079gj5">
        <h2 className="text-center font-display text-[1.4rem] font-extrabold uppercase leading-none text-white sm:text-[1.95rem]" data-id="element-31" data-mp="2crfl8wt5xdqj">
          BUILT FOR REAL <span className="text-hazard" data-id="element-32" data-mp="27ymde02edpa8">CONSTRUCTION SITE CHALLENGES</span>
        </h2>
        <ul className="mt-2 divide-y divide-line overflow-hidden rounded-md border border-line bg-ink" data-id="element-33" data-mp="2lqap428qibqo">
          {challenges.map(c => <li key={c.quote} className="px-2.5 py-2" data-id="element-34" data-mp="2hsd4lcpwsdtm">
              <p className="font-display text-[0.82rem] font-bold leading-tight text-white sm:text-[0.98rem]" data-id="element-35" data-mp="2voguittr200a">
                <span aria-hidden="true" data-id="element-36" data-mp="2qr8bkr0s1rxz">{c.emoji}</span> <span className="text-hazard" data-id="element-37" data-mp="11bikmbbyp5dh">“{c.quote}”</span>
              </p>
              <p className="mt-0.5 text-[0.78rem] leading-[1.35] text-steel sm:text-[0.9rem]" data-id="element-38" data-mp="11dljzlz08auv">{c.body}</p>
            </li>)}
        </ul>
      </div>
    </section>;
}